module.exports = __webpack_public_path__ + "img/recommendation-6.6fdc498c.svg";